import { CreateRequestModel, CustomFieldDto } from 'models/CreateRequestModel';
import { CreateZendeskRequestProps, Subject } from './types';
import { SupportProductModel } from 'models/SupportProductModel';

const isDefined = <T>(value: T | null): value is T => value !== null;

//Zendesk fields ids
export const orderFieldId = '29744490577042';
export const productFieldId = '30573105566482';
export const customerPhoneId = '29748190128018';
export const companyNameId = '32312858973074';

export const createZendeskRequest = ({
  formId,
  email,
  name,
  formTitle = '',
  body,
  uploads = [],
  formSubject,
  reason,
  orderId,
  orderFieldId,
  products,
  productNumber,
  productFieldId,
  phoneNumber,
  phoneNumberFieldId,
  companyName,
  companyNameFieldId
}: CreateZendeskRequestProps): CreateRequestModel => {
  const reasonField = createReasonField(reason);
  const productField = createProductField(productFieldId, products, productNumber);
  const orderIdField = createCustomField(orderFieldId, orderId);
  const phoneNumberField = createCustomField(phoneNumberFieldId, phoneNumber);
  const companyNameField = createCustomField(companyNameFieldId, companyName);

  const subjectValue = formSubject.array.find(s => s.id === formSubject.id)?.tag ?? '';
  const customFields: CustomFieldDto[] = [
    {
      id: formSubject.fieldId,
      values: [subjectValue]
    },
    reasonField,
    productField,
    orderIdField,
    phoneNumberField,
    companyNameField
  ].filter(isDefined);

  return {
    ticketFormId: formId,
    email,
    name,
    subject: formTitle,
    body,
    uploads,
    customFields
  };
};

const createCustomField = (fieldId?: string, value?: string): CustomFieldDto | null => {
  if (!fieldId || !value) {
    return null;
  }
  return {
    id: fieldId,
    values: [value]
  };
};

const createReasonField = (reason?: Subject): CustomFieldDto | null => {
  if (!reason?.id) {
    return null;
  }
  const reasonValue = reason.array.find(s => s.id === reason.id)?.tag ?? '';
  return {
    id: reason.fieldId,
    values: [reasonValue]
  };
};

const createProductField = (
  fieldId?: string,
  products?: SupportProductModel[],
  productNumber?: string
): CustomFieldDto | null => {
  if (!fieldId) {
    return null;
  }

  if (products) {
    const productsString = products.map(p => `${p.quantity} pc ${p.productId}`).join(' \n');

    return {
      id: fieldId,
      values: [productsString]
    };
  }
  if (productNumber) {
    return {
      id: fieldId,
      values: [productNumber]
    };
  }
  return null;
};
